export default "__VITE_ASSET__Ci9K_dKg__";